import React from "react";
import {
  ActivityIndicator,
  FlatList,
  SafeAreaView,
  StyleSheet,
  Text,
  View,
} from "react-native";
import { Room } from "../../../../types/types";
import Illustration from "../../../../assets/Illustration";
import MeetingOption from "../components/MeetingOption";
import CreateMeetingButton from "../components/CreateMeetingButton";

type Props = {
  rooms: Room[];
  loading: boolean;
  errorText: string | null;
  getParticipantsCount: (room: Room) => number;
  isRoomDisabled: (room: Room) => boolean;
  getDisabledActionLabel: (room: Room) => string | undefined;
  onRoomPress: (room: Room) => void;
  onPressSchedule: () => void;
};

export default function AllMeetingsViewMobile({
  rooms,
  loading,
  errorText,
  getParticipantsCount,
  isRoomDisabled,
  getDisabledActionLabel,
  onRoomPress,
  onPressSchedule,
}: Props) {
  return (
    <SafeAreaView style={styles.container}>
      {loading && <ActivityIndicator size="large" style={styles.loading} />}
      {errorText && <Text style={styles.errorText}>{errorText}</Text>}

      <FlatList
        data={rooms}
        keyExtractor={(item: Room) => item.id}
        contentContainerStyle={styles.listContainer}
        renderItem={({ item }: { item: Room }) => (
          <View style={styles.cardWrapper}>
            <MeetingOption
              room={item}
              isSelected={false}
              onSelect={() => onRoomPress(item)}
              participantsCount={getParticipantsCount(item)}
              isDisabled={isRoomDisabled(item)}
              disabledActionLabel={getDisabledActionLabel(item)}
            />
          </View>
        )}
        ListEmptyComponent={
          !loading ? (
            <View style={styles.emptyContainer}>
              <Illustration width={307} height={268} />
              <View style={styles.textBlock}>
                <Text style={styles.emptyTitle}>Available Conversations</Text>
                <Text style={styles.emptyText}>
                  There are no conversations available right now. You can check
                  back later, or start your own when you feel ready.
                </Text>
              </View>
              <CreateMeetingButton
                onPress={onPressSchedule}
                size={47}
                lineLength={25.99}
                lineThickness={4.41}
              />
            </View>
          ) : null
        }
      />
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#F6F7F9",
  },
  loading: {
    marginTop: 20,
  },
  errorText: {
    color: "red",
    textAlign: "center",
    fontFamily: "Lexend",
    marginTop: 12,
  },
  listContainer: {
    paddingHorizontal: 16,
    paddingTop: 24,
    paddingBottom: 32,
    flexGrow: 1,
  },
  cardWrapper: {
    width: "100%",
    maxWidth: 343,
    alignSelf: "center",
  },
  emptyContainer: {
    flexGrow: 1,
    alignItems: "center",
    paddingTop: 48,
    paddingHorizontal: 16,
    paddingBottom: 16,
    gap: 38,
  },
  textBlock: {
    width: "100%",
    maxWidth: 343,
    alignItems: "center",
    gap: 16,
  },
  emptyTitle: {
    fontSize: 26,
    lineHeight: 28,
    fontFamily: "LexendBold",
    color: "#2B2B2F",
    textAlign: "center",
  },
  emptyText: {
    fontSize: 16,
    lineHeight: 20,
    fontFamily: "Lexend",
    color: "#2B2B2F",
    textAlign: "center",
    opacity: 0.6,
  },
});
